export class ResponseDgtIndicador {
    indicador: string; 
    valor: string;
  }
